var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0607 9.07531C14.4749 9.6611 13.5251 9.6611 12.9393 9.07531L8 4.13597L3.06066 9.07531C2.47487 9.6611 1.52513 9.6611 0.93934 9.07531C0.353553 8.48952 0.353553 7.53978 0.939341 6.95399L6.93934 0.953988C7.52513 0.368202 8.47487 0.368202 9.06066 0.953989L15.0607 6.95399C15.6464 7.53978 15.6464 8.48952 15.0607 9.07531Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.4687de5cf23d1f70487ef01b055b49dc.svg";
export { ForwardRef as ReactComponent };